(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailTemplatesListCtrl', EmailTemplatesListCtrl);

    EmailTemplatesListCtrl.$inject = ['$q', '$routeParams', 'SystemService', 'DialogService', 'ChilliUserProfileService', 'WindowTitleService'];

    function EmailTemplatesListCtrl($q, $routeParams, SystemService, DialogService, ChilliUserProfileService, WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.showPanel = showPanel;
        vm.loading = true;
        vm.permissionDenied = false;

        activate();

        function activate() {
            WindowTitleService.setTitle('Email Templates');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                var loadPromises = [];
                loadPromises.push(loadListPageSize());

                return $q.all(loadPromises).then(function () {
                    var dashboardSettingConfiguration = { Fields: ['Description'] };
                    dashboardSettingConfiguration.ListPageSize = vm.ListPageSize;

                    if (!_.isNil($routeParams.entityTemplateId)) {
                        dashboardSettingConfiguration.EntityTemplateId = $routeParams.entityTemplateId;
                    } 

                    vm.dashboardSettingConfiguration = angular.copy(dashboardSettingConfiguration);
                });
            }
        }

        function loadListPageSize() {
            return SystemService.getMenuListSize('Email Templates')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                vm.ListPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        function showPanel() {
            var result = false;

            if (!angular.isUndefined(vm.dashboardSettingConfiguration) && vm.dashboardSettingConfiguration !== null) {
                result = true;
            }

            return result;
        }
    }
})();
